export default __webpack_public_path__ + "static/media/reCAPTCHA-logo@2x.88fb6de3.png";